<template>
  <div style="margin: 24px">
    <el-card :body-style="{ padding: '24px' }" shadow="never">
      <!-- 顶部滑动选择器 Tabs -->
      <el-tabs
        v-model="activeTab"
        stretch
        style="width: 390px"
        @tab-click="handleTabChange"
      >
        <el-tab-pane
          v-for="item in tabOptions"
          :key="item.name"
          :label="`${item.label}（${item.count}）`"
          :name="item.name"
        />
      </el-tabs>

      <!-- 搜索与操作区 -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        "
      >
        <div>
          <!-- 自定义按钮样式 -->
          <button
            class="custom-btn"
            style="margin-right: 24px"
            @click="requestNotifyPermission"
          >
            通知权限
          </button>
          <button
            class="custom-btn"
            :disabled="!hasSelected"
            style="margin-right: 24px"
            @click="markAsRead"
          >
            标为已读
          </button>
          <button
            class="custom-btn"
            :disabled="!hasSelected"
            @click="deleteMsg"
          >
            删除
          </button>
        </div>
        <div style="display: flex; align-items: center; gap: 8px">
          <span style="color: #4e5969; font-size: 14px">消息状态：</span>
          <el-select
            v-model="status"
            placeholder="消息状态"
            style="width: 110px; margin-right: 24px"
          >
            <el-option label="全部" value="all" />
            <el-option label="已读" value="read" />
            <el-option label="未读" value="unread" />
          </el-select>
          <el-input
            v-model="search"
            placeholder="请输入消息标题"
            style="width: 210px"
            clearable
            prefix-icon="el-icon-search"
          />
        </div>
      </div>

      <!-- 消息列表 -->
      <el-table
        :data="filteredData"
        style="width: 100%; border: none; cursor: pointer"
        :header-cell-style="{ background: '#F5F7FA', color: '#606266' }"
        row-key="id"
        @selection-change="handleSelectionChange"
        @row-click="openDetail"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column prop="detail" label="消息详情" min-width="360">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.status_text === '未读' ? '#F53F3F' : '#C9CDD4',
                fontWeight: 'bold',
                fontSize: '20px',
                marginRight: '5px',
                display: 'inline-block'
              }"
            >·</span>
            <span class="msg-detail-text">{{ scope.row.detail }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type_text" label="消息类型" width="120" />
        <el-table-column prop="time" label="消息时间" width="180" />
      </el-table>

      <!-- 分页 -->
      <div style="margin-top: 24px; text-align: right">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="totalData"
          :page-size="pageSize"
          :current-page.sync="currentPage"
        />
      </div>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog
      :visible.sync="detailVisible"
      width="520px"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      title="消息详情"
    >
      <div v-if="currentMsg">
        <div class="detail-row">
          <span class="detail-label">标题：</span>{{ currentMsg.title || currentMsg.detail || '-' }}
        </div>
        <div class="detail-row" style="white-space: pre-wrap">
          <span class="detail-label">内容：</span>{{ currentMsg.content || '-' }}
        </div>
        <div class="detail-row">
          <span class="detail-label">类型：</span>{{ currentMsg.type_text || currentMsg.type || '-' }}
        </div>
        <div class="detail-row">
          <span class="detail-label">状态：</span>{{ currentMsg.status_text || '-' }}
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button
          type="primary"
          :disabled="!currentMsg || !currentMsg.url"
          @click="goDetail"
        >
          前往处理
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  notificationList,
  notificationReaded,
  delNotification,
  notificationStatistics
} from '../../api/notify'

export default {
  data() {
    return {
      // 👉 ElementUI 的 el-tab-pane.name 需要 String
      // 业务含义：'0'=全部, '1'=用户提醒, '2'=公告通知
      activeTab: '0',
      tabOptions: [
        { label: '全部', name: '0', count: 0 },
        { label: '用户提醒', name: '1', count: 0 },
        { label: '公告通知', name: '2', count: 0 }
      ],
      status: 'all', // all/read/unread -> 后端 0/2/1
      search: '',
      // 列表/分页
      msgList: [],
      backendTotal: 0,
      pageSize: 10,
      currentPage: 1,
      selectedRows: [],
      searchTimer: null,
      // 详情
      detailVisible: false,
      currentMsg: null
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRows.length > 0
    },
    filteredData() {
      return this.msgList
    },
    totalData() {
      return this.backendTotal
    }
  },
  watch: {
    activeTab() {
      this.currentPage = 1
      this.fetchList()
      this.fetchStatistics()
    },
    status() {
      this.currentPage = 1
      this.fetchList()
    },
    currentPage() {
      this.fetchList()
    },
    search() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1
        this.fetchList()
      }, 300)
    }
  },
  created() {
    this.fetchList()
    this.fetchStatistics()
  },
  methods: {
    handleTabChange() {
      this.currentPage = 1
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows
    },

    // 前端状态 -> 后端整型
    mapStatusToInt() {
      // 后端: 0=全部 1=未读 2=已读
      if (this.status === 'unread') return 1
      if (this.status === 'read') return 2
      return 0
    },

    async fetchList() {
      const params = {
        page: Number(this.currentPage) || 1, // int
        page_size: Number(this.pageSize) || 10, // int
        status: Number(this.mapStatusToInt()), // int
        type: Number(this.activeTab) // int: 0/1/2
      }
      const kw = this.search && this.search.trim()
      if (kw) params.keyword = kw // 只有有值时才传，且为 string

      try {
        const res = await notificationList(params)
        const data = res?.data || {}
        const list = Array.isArray(data.list)
          ? data.list
          : Array.isArray(data)
            ? data
            : []
        const total =
          typeof data.total === 'number' ? data.total : res.total || 0
        this.backendTotal = total
        const maxPage = Math.max(1, Math.ceil(total / this.pageSize))
        if (this.currentPage > maxPage) {
          this.currentPage = maxPage
          // 直接 return，触发 watch(currentPage) 再次 fetchList
          return
        }
        // 字段归一 + 保留用于详情/跳转的字段
        this.msgList = list.map((item) => ({
          id: item.id,
          // 列表主文案：优先 detail，其次 title
          detail: item.detail || item.title || '',
          // 详情所需
          title: item.title || '',
          content: item.content || '',
          url: item.url || '',
          param: item.param || null,
          // 类型/状态（数值 + 文案）
          type: item.type,
          status: item.status,
          type_text: item.type_text || item.type || '',
          status_text:
            item.status_text || (item.is_read === 1 ? '已读' : '未读'),
          // 时间
          time: item.time || item.created_at || ''
        }))
      } catch (e) {
        this.$message.error('获取消息失败')
      }
    },

    async fetchStatistics() {
      try {
        const res = await notificationStatistics()
        const stats = res?.data || []
        // 后端 type: 0=全部 1=用户提醒 2=公告通知
        const counters = { 0: 0, 1: 0, 2: 0 }
        stats.forEach((s) => {
          counters[String(s.type)] = s.total || 0
        })
        this.tabOptions = this.tabOptions.map((t) => ({
          ...t,
          count: counters[t.name] || 0
        }))
      } catch (e) {
        console.warn('获取消息统计失败：', e)
      }
    },

    // 点击行 -> 打开详情，并标记为已读（乐观更新 + 失败回滚）
    async openDetail(row) {
      this.currentMsg = row
      this.detailVisible = true
      // 已读就不再请求
      if (row.status_text === '已读') return
      const prev = row.status_text
      // 乐观更新：立即改为已读，给用户即时反馈
      this.$set(row, 'status_text', '已读')

      try {
        await notificationReaded({ ids: [String(row.id)] })

        this.fetchStatistics()
        this.fetchList()
        this.notifyGlobalChange() // 通知 Navbar 刷角标
      } catch (e) {
        // 回滚
        this.$set(row, 'status_text', prev)
        this.$message.error('标记已读失败')
      }
    },

    // 路由跳转（支持 "#/xxx" 或完整域名）
    goDetail() {
      if (!this.currentMsg || !this.currentMsg.url) return
      let raw = this.currentMsg.url

      // 1. 去掉协议和域名（如果有）
      try {
        // 用 URL 构造器安全解析
        const u = new URL(raw, window.location.origin)
        raw = u.hash ? u.hash : u.pathname + u.search
      } catch (e) {
        console.warn('跳转失败', e)
      }

      // 2. 去掉开头的 #
      const path = raw.replace(/^#/, '')

      // 3. 附带参数
      const query =
        this.currentMsg.param && typeof this.currentMsg.param === 'object'
          ? this.currentMsg.param
          : {}

      this.$router.push({ path, query })
      this.detailVisible = false
    },

    // 批量标记已读
    markAsRead() {
      const ids = this.selectedRows.map((r) => String(r.id))
      if (!ids.length) return
      // 乐观更新：先把本地选中项置为已读
      const prevMap = new Map()
      this.selectedRows.forEach((r) => {
        prevMap.set(r.id, r.status_text)
        this.$set(r, 'status_text', '已读')
      })

      notificationReaded({ ids })
        .then(() => {
          this.$message.success('已标为已读！')
          this.selectedRows = []
          this.fetchStatistics()
          this.fetchList()
          this.notifyGlobalChange()
        })
        .catch(() => {
          // 失败回滚
          this.msgList.forEach((r) => {
            if (prevMap.has(r.id)) {
              this.$set(r, 'status_text', prevMap.get(r.id))
            }
          })
          this.$message.error('标记已读失败')
        })
    },

    // 批量删除
    deleteMsg() {
      this.$confirm('确定要删除选中消息吗？', '提示', { type: 'warning' })
        .then(() => {
          const ids = this.selectedRows.map((r) => String(r.id))
          if (!ids.length) return
          delNotification({ ids })
            .then(() => {
              this.$message.success('已删除选中消息！')
              this.selectedRows = []
              this.fetchList()
              this.fetchStatistics()
            })
            .catch(() => this.$message.error('删除失败'))
        })
        .catch((err) => {
          if (err === 'cancel' || err === 'close') {
            this.$message.info('已取消删除')
            return
          }
          console.error('删除确认弹窗异常：', err)
          this.$message.error('操作失败，请稍后重试')
        })
    },
    notifyGlobalChange() {
      window.dispatchEvent(new Event('notify:changed'))
    },
    async requestNotifyPermission() {
      // 运行环境检查
      if (typeof window === 'undefined') return
      if (!('Notification' in window)) {
        this.$message.error('当前浏览器不支持通知 API')
        return
      }
      // 非 https 的提醒（localhost 例外）
      const insecure =
        location.protocol !== 'https:' && location.hostname !== 'localhost'
      if (insecure) {
        this.$message.warning('通知权限需要 HTTPS 或 localhost 环境')
        return
      }

      // 如果已授权：直接给出测试通知，并询问是否调用 notify.authorize()
      if (Notification.permission === 'granted') {
        try {
          new Notification('🔔 通知已开启', { body: '你已经授予通知权限' })
        } catch (e) { console.error(e) }
        if (window.notify && typeof window.notify.authorize === 'function') {
          this.$confirm(
            '已拥有通知权限，是否现在调用 notify.authorize() 进行对接？',
            '确认',
            {
              type: 'info',
              confirmButtonText: '调用',
              cancelButtonText: '取消'
            }
          )
            .then(() => {
              try {
                window.notify.authorize()
                this.$message.success('已调用 notify.authorize()')
              } catch (e) {
                this.$message.error('notify.authorize() 调用失败')
              }
            })
            .catch((e) => { console.error(e) })
        } else {
          this.$message.info(
            '已授权：未检测到 window.notify.authorize，可忽略此步骤'
          )
        }
        return
      }

      // 未授权/待询问：唤起权限弹窗（按钮点击属于用户手势，可直接请求）
      try {
        const res = await Notification.requestPermission()
        console.log('Notification permission:', res)
        if (res === 'granted') {
          try {
            new Notification('✅ 通知测试', { body: '当前站点已获得通知权限' })
          } catch (e) { console.error(e) }
          if (window.notify && typeof window.notify.authorize === 'function') {
            this.$confirm(
              '已允许通知。是否调用 notify.authorize() 完成授权对接？',
              '确认',
              {
                type: 'info',
                confirmButtonText: '调用',
                cancelButtonText: '稍后'
              }
            )
              .then(() => {
                try {
                  window.notify.authorize()
                  this.$message.success('已调用 notify.authorize()')
                } catch (e) {
                  this.$message.error('notify.authorize() 调用失败')
                }
              })
              .catch((e) => { console.error(e) })
          } else {
            this.$message.success('通知权限已开启')
          }
        } else if (res === 'denied') {
          this.$alert(
            '你拒绝了通知权限。可在地址栏左侧“站点设置”里把“通知”改为“允许”，或清除后重试。',
            '已拒绝',
            { type: 'warning' }
          )
        } else {
          this.$message.info('已发起权限请求，请在浏览器弹窗中选择是否允许')
        }
      } catch (err) {
        this.$message.error('请求通知权限失败')
      }
    }
  }
}
</script>

<style scoped>
.custom-btn {
  background: #f2f3f5;
  color: #4e5969;
  border: none;
  border-radius: 4px;
  height: 36px; /* 总高度32px */
  line-height: 20px; /* 字体垂直居中 */
  padding: 0 16px; /* 左右16px，上下0 */
  cursor: pointer;
  transition: background 0.15s;
  outline: none;
  font-size: 14px;
  user-select: none;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center; /* 保证内容垂直居中 */
  justify-content: center;
}
.custom-btn:not(:disabled):hover {
  background: #e5e6eb;
  color: #4e5969;
}
.custom-btn:not(:disabled):active {
  background: #c9cdd4;
  color: #4e5969;
}
.custom-btn:disabled {
  background: #f7f8fa;
  color: #c9cdd4;
  cursor: not-allowed;
}

.msg-detail-text {
  display: inline-block;
  vertical-align: middle;
}

.detail-row {
  margin-bottom: 8px;
  line-height: 1.6;
}
.detail-label {
  color: #86909c;
}
</style>
